<div>
  @if (showSplashScreenComponent$ | async) {
    <app-splash-screen-page [attr.data-app]="'true'"></app-splash-screen-page>
  }
  <router-outlet></router-outlet>
  @if (!themeConfig.isAnalyticsMode && publicMode !== undefined) {
    <app-x-chat-support [publicMode]="publicMode" />
  }
  <app-x-information-bar></app-x-information-bar>
  <app-download-app-overlay></app-download-app-overlay>
  @if (environment.postHogEnabled === true) {
    <app-cookie-banner />
  }
</div>
